import { lazy } from 'react';

export const ErrorPage = lazy(() => import('./ui/ErrorPage'));
